import React, {useContext, useEffect, useState} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import UIPopupContext from "../../popups/UIPopup/UIPopupContext";
import {getLookList} from "../../look/lookNavigation/lookFunctions";

import {getCurrentPrompts} from "../aiApi";
import UiPopupAIContentFeatureGroups from "./UiPopupAIContentFeatureGroups";
import UiPopupAIContentPrompts from "./UiPopupAIContentPrompts";
import UiPopupAIContentMainPrompt from "./UiPopupAIContentMainPrompt";
import UiPopupAIContentResult from "./UiPopupAIContentResult";
import LoadingSpinner from "../../ui/loadingSpinner";


const UiPopupAIContent = () => {

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);
  const {userFile} = uiPopupContext;

  const [loading, setLoading] = useState(true);

  const setInitialAiLogic = async () => {
    setLoading(true);
    const promptsList = await getCurrentPrompts();
    setLoading(false);
    const lookList = getLookList();
    uiPopupDispatch({
      userFile: null,
      promptsList,
      saveButtonDisabled: true,
      groupObjects: lookList
        .filter(groupObject => groupObject.featureGroup && groupObject.featureGroup.activeFeature)
        .map(groupObject => {
          groupObject.enabled = true;
          return groupObject
        }),
    });
  }

  useEffect(() => {
    setInitialAiLogic();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFileChange = (event) => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    uiPopupDispatch({
      userFile: event.target.files[0],
      saveButtonDisabled: false,
    });
  }

  return (
    <div className="h-full w-full pl-075 pr-075 scrollable relative">
      {loading ? <LoadingSpinner size="smaller"/> : (
        <div>
          <div className="product-actions__title bold text-left mb-1 scart-block__list-item-text-title mt-0">01. Upload File</div>
          <div className="flex mb-1">
            <label className="link link--blue" htmlFor="aiFileUpload">Upload File {userFile ?
              <span className={"pl-1 h-1 leading-1 color-active bold"}>{userFile.name}</span> : null}
            </label>
            <input type="file" id="aiFileUpload" accept="image/*" className="display-none" onChange={onFileChange}/>
          </div>
          <div className="product-actions__title bold text-left mb-1 scart-block__list-item-text-title mt-0">02. Select First Prompt</div>
          <div className="flex flex--center flex--between mb-1" style={{height: "200px"}}>
            <div className="pr-05 h-full" style={{width: "200px"}}>
              <UiPopupAIContentPrompts type={"First"}/>
            </div>
            <div className="pl-05 pr-05 flex flex--1 flex--center flex--column h-full">
              <UiPopupAIContentMainPrompt type={"First"}/>
            </div>
            <div className="pl-05 pr-05 h-full flex--1">
              <UiPopupAIContentFeatureGroups type={"First"}/>
            </div>
          </div>
          <div className="product-actions__title bold text-left mb-1 scart-block__list-item-text-title mt-0">03. Select Second Prompt</div>
          <div className="flex flex--center flex--between mb-1" style={{height: "200px"}}>
            <div className="pr-05 flex flex--center flex--column h-full" style={{width: "200px"}}>
              <UiPopupAIContentPrompts type={"Second"}/>
            </div>
            <div className="pl-05 pr-05 flex flex--1 flex--center flex--column h-full">
              <UiPopupAIContentMainPrompt type={"Second"}/>
            </div>
            <div className="pl-05 pr-05 flex flex--1 flex--center flex--column h-full" style={{height: "200px"}}>
              <UiPopupAIContentFeatureGroups type={"Second"}/>
            </div>
          </div>
          <div className="product-actions__title bold text-left mb-1 scart-block__list-item-text-title mt-0">04. Get Render Result</div>
          <UiPopupAIContentResult/>
        </div>
      )}
    </div>
  )
};

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;

  return {
    fabricatorData,
  };
};

export default injectIntl(
  connect(mapStateToProps)(UiPopupAIContent)
)

